import { Link } from "react-router-dom";
import { ClipboardCheck, ArrowRight } from "lucide-react";

// Home CTA to the personal PJC page. Always visible — no "already done today"
// state since multiple entries per day are allowed.
export default function PjcTodayCard() {
  return (
    <Link
      to="/pjc/mine"
      data-testid="pjc-today-card"
      className="brutal-card p-4 flex items-center gap-3 bg-amber-50 border-amber-300 transition-transform hover:-translate-y-[1px]"
    >
      <div className="w-10 h-10 rounded-lg text-white flex items-center justify-center shrink-0 bg-[#F5A623]">
        <ClipboardCheck size={20} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="label-up">Pre-Job Check</div>
        <div className="font-display font-black text-lg leading-tight text-[#0B2A4A]">
          Rellenar antes de empezar
        </div>
        <div className="text-[11px] text-slate-500 truncate">
          Historial personal · abre para nuevo o consultar
        </div>
      </div>
      <ArrowRight size={16} className="text-slate-400 shrink-0" />
    </Link>
  );
}
